
import {Component, Prop, Vue} from "vue-property-decorator";
import {stringify} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";

// const UnknownPart = "UK";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EmptyPart2 = "XX";

@Component({
  name: 'MedicalDateFieldReadonly',
  components: {
  },
})
export default class MedicalDateFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  menu = false;

  get day() {
    return this.dataField.values.day ?? ""
  }

  get needsDay() {
    return this.dataField.definition.needsDay
  }

  get month() {
    return this.dataField.values.month ?? "";
  }

  get needsMonth() {
    return this.dataField.definition.needsMonth;
  }

  get year() {
    return this.dataField.values.year ?? ""
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  get ongoing() {
    return this.dataField.values.ongoing
  }

  get datePicker() {
    const date = new Date(this.dataField?.values?.value);
    if (date instanceof Date && !isNaN(date.getTime()))
      return this.dataField?.values?.value
    return ""
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get dateDisabled() {
    return this.ongoingDisabled || this.unknownDisabled;
  }

  get ongoingDisabled() {
    return this.unknown ?? false;
  }

  get unknownDisabled() {
    return this.ongoing ?? false;
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get canMonthBeUnknown() {
    return this.field.definition.canMonthBeUnknown ?? false;
  }

  get canDayBeUnknown() {
    return this.field.definition.canDayBeUnknown ?? false;
  }

  get canBeOngoing() {
    return this.field.definition.canBeOngoing ?? false;
  }

  get field() {
    return this.dataField;
  }

}
